// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"7666a1ca","453":"59235980"}[chunkId] + ".chunk.js";
};